<script>
export default {
  data() {
    return
  },
  methods: {
    getImg(id, fn) {
      this.$axios({
        method: 'get',
        url: `/prod-api/file/preViewImage/${id}`,
        responseType: 'blob',
        headers: {
          Authorization: 'Bearer ' + localStorage.TOKEN
        }
      }).then(res => {
        const dataInfo = res.data
        let reader = new window.FileReader()
        let content = res.headers['content-disposition'].split(';')
        let fileName = decodeURI(content[1].split('=')[1])
        // 使用readAsArrayBuffer读取文件, result属性中将包含一个 ArrayBuffer 对象以表示所读取文件的数据
        reader.readAsArrayBuffer(dataInfo)
        reader.onload = e => {
          const result = e.target.result
          const contentType = dataInfo.type
          // 生成blob图片,需要参数(字节数组, 文件类型)
          const blob = new Blob([result], { type: contentType })
          // 使用 Blob 创建一个指向类型化数组的URL, URL.createObjectURL是new Blob文件的方法,可以生成一个普通的url,可以直接使用,比如用在img.src上
          const url = window.URL.createObjectURL(blob)
          fn(url, fileName)
        }
      })
    }
  }
}
</script>
